import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cart-breadcrumb',
  templateUrl: './cart-breadcrumb.component.html',
  styleUrls: ['./cart-breadcrumb.component.css']
})
export class CartBreadcrumbComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
